var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapReverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25909 7.83336H1.74992C1.24575 7.83336 0.833252 8.24586 0.833252 8.75003C0.833252 9.25419 1.24575 9.66669 1.74992 9.66669H7.25909V11.3075C7.25909 11.72 7.75409 11.9217 8.03825 11.6284L10.5866 9.07086C10.7608 8.88753 10.7608 8.60336 10.5866 8.42003L8.03825 5.86253C7.75409 5.56919 7.25909 5.78003 7.25909 6.18336V7.83336ZM12.7408 5.80753V4.16669H18.2499C18.7541 4.16669 19.1666 3.75419 19.1666 3.25003C19.1666 2.74586 18.7541 2.33336 18.2499 2.33336H12.7408V0.692528C12.7408 0.280028 12.2458 0.0783613 11.9616 0.371695L9.41325 2.92919C9.23909 3.11253 9.23909 3.39669 9.41325 3.58003L11.9616 6.13753C12.2458 6.42169 12.7408 6.22003 12.7408 5.80753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapReverseIcon);
export default __webpack_public_path__ + "static/media/swap-reverse-icon.052799d622d678b665fb3837de41ebe4.svg";
export { ForwardRef as ReactComponent };